module.exports = __webpack_public_path__ + "static/media/hjul.220649bd.mp3";